import Vue from 'vue'
import Vuex from 'vuex'
import lookupsModule from './modules/lookupsModule'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authCode: '',
    authUser: {
      initials: "",
      fullName: "",
      email: "",
      id_profile_user: "",
      id_unity_user: "",
      unity_name: "",
    },
    successMessage: '',
    errorMessage: '',
    stepperPatient: true,
    stepperVisitors: false,
    aghusePatient: {},
    viewPatient: false,
    personTypeCount: {
      qtyVisitor: '',
      qtyEscort: '',
      save: true,
      limit: '',
    },
  },
  getters: {
    getPersonTypeCount(state) {
      return state.personTypeCount
    },
    isCounted(getters) {
      return (getters.personTypeCount.qtyEscort >= 0 || getters.personTypeCount.qtyVisitor >= 0) ? true : false
    }
  },
  mutations: {
    setPersonTypeCount(state, payload) {
      state.personTypeCount = payload
    },
    setAuthUser(state, userData){
      state.authUser = userData
    }
  },
  actions: {
    
  },
  modules: {
    lookupsModule
  },
  plugins: [createPersistedState({
    key: 'lookups',
    paths: ['lookupsModule'] 
  })]
})
